import React from 'react';
import { Form, Input, Button,Select,Spin,Switch } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const { Option } = Select;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var sacco= ''
var token= ''

class LoanTypeForm extends React.Component {

  state = {
    loan_type_name:'',
    loan_form_fees:0,
    loan_assessment_fees:0,
    loan_insurance_fee:0,
    loan_commitment_fee:0,
    loan_agreement_fees:0,
    reserve_fees:0,
    interest_rate:0,
    maximum_loan_amount:0,
    maximum_period:0,

    interestrate_type:'flatinterest',
    loan_primary_schedule:'monthly',
    no_of_times_collateral_againstloanamount:0,
    no_of_approvers:0,

    pmt_formular_enabled_onreducingbalance:false,

    account_tocreditloanprinciple_ondeposit:0,
    account_tocreditloaninterest_ondeposit:0,
    account_todebitloaninterest_ondeposit:0,

    account_todebit_onloan_onloanissuance:0,
    account_tocredit_onloanfees_onloanissuance:0,
    account_tocredit_onbankcharge_onloanissuance:0,

    account_todebit_on_acculatedloanfines:0,
    account_tocredit_on_paidloanfines:0,

    account_tocredit_onreservefee:0,
    account_tocredit_onassessment_fees:0,
    account_tocredit_oninsurance_fee:0,
    account_tocredit_oncommitment_fee:0,
    account_tocredit_onagreement_fees:0,

    companyaccounts:[],
    transfer_tosavings_onissuance:false,
    send_sms_onissuance:false,
    send_sms_on_repayment:false,
    charges_from:'loan',

    photograph_fees:0,
    account_tocredit_onphotograph_fees:0,
    loan_limitby:'collateral_value_division',
    autoPayments_afterfullcycle:false


  }



  componentDidMount(){

    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

   // this.setState({datarequested:false})

    axios.get(serverconfig.backendserverurl+`/api/companyaccounts/?sacco=${sacco}`)
    .then(res => {
        this.setState({
            companyaccounts:res.data
        })
        this.setState({datarequested:false})
    })
}


  //submit button pressed
  handleFormSubmit=(event) =>{
    this.setState({datarequested:true})

    let form_data = new FormData();
    form_data.append('loan_type_name', this.state.loan_type_name);
    form_data.append('loan_form_fees', this.state.loan_form_fees);

    form_data.append('loan_assessment_fees', this.state.loan_assessment_fees);
    form_data.append('loan_insurance_fee', this.state.loan_insurance_fee);
    form_data.append('loan_commitment_fee', this.state.loan_commitment_fee);
    form_data.append('loan_agreement_fees', this.state.loan_agreement_fees);
    form_data.append('reserve_fees', this.state.reserve_fees);
    form_data.append('interest_rate', this.state.interest_rate);
    form_data.append('maximum_loan_amount', this.state.maximum_loan_amount);
    form_data.append('maximum_period', this.state.maximum_period);
    form_data.append('sacco', sacco);

    form_data.append('loan_primary_schedule', this.state.loan_primary_schedule);
    form_data.append('interestrate_type', this.state.interestrate_type);
    form_data.append('no_of_times_collateral_againstloanamount', this.state.no_of_times_collateral_againstloanamount);
    form_data.append('no_of_approvers', this.state.no_of_approvers);

    //new additions now
    form_data.append('pmt_formular_enabled_onreducingbalance', this.state.pmt_formular_enabled_onreducingbalance);
    form_data.append('transfer_tosavings_onissuance', this.state.transfer_tosavings_onissuance);

    form_data.append('account_tocreditloanprinciple_ondeposit', this.state.account_tocreditloanprinciple_ondeposit);
    form_data.append('account_tocreditloaninterest_ondeposit', this.state.account_tocreditloaninterest_ondeposit);
    form_data.append('account_todebitloaninterest_ondeposit', this.state.account_todebitloaninterest_ondeposit);

    form_data.append('account_todebit_onloan_onloanissuance', this.state.account_todebit_onloan_onloanissuance);
    form_data.append('account_tocredit_onloanfees_onloanissuance', this.state.account_tocredit_onloanfees_onloanissuance);
    form_data.append('account_tocredit_onbankcharge_onloanissuance', this.state.account_tocredit_onbankcharge_onloanissuance);

    form_data.append('account_todebit_on_acculatedloanfines', this.state.account_todebit_on_acculatedloanfines);
    form_data.append('account_tocredit_on_paidloanfines', this.state.account_tocredit_on_paidloanfines);

    form_data.append('account_tocredit_onreservefee', this.state.account_tocredit_onreservefee);
    form_data.append('account_tocredit_onassessment_fees', this.state.account_tocredit_onassessment_fees);
    form_data.append('account_tocredit_oninsurance_fee', this.state.account_tocredit_oninsurance_fee);
    form_data.append('account_tocredit_oncommitment_fee', this.state.account_tocredit_oncommitment_fee);
    form_data.append('account_tocredit_onagreement_fees', this.state.account_tocredit_onagreement_fees);

    form_data.append('charges_from', this.state.charges_from);
    form_data.append('send_sms_onissuance', this.state.send_sms_onissuance);
    form_data.append('send_sms_on_repayment', this.state.send_sms_on_repayment);


    form_data.append('photograph_fees', this.state.photograph_fees);
    form_data.append('account_tocredit_onphotograph_fees', this.state.account_tocredit_onphotograph_fees);

    form_data.append('loan_limitby', this.state.loan_limitby);
    form_data.append('autoPayments_afterfullcycle', this.state.autoPayments_afterfullcycle);

    axios.post(serverconfig.backendserverurl+'/api/loantypes/', form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  .then(res =>   this.setState({datarequested:false})
,  window.location.reload(false)
  )
  .catch(error => console.log(error))

  }

 
 
  handleloan_type_nameChange= (e) => this.setState({ loan_type_name: e.target.value});
  handleloan_form_feesChange= (e) => this.setState({ loan_form_fees: e.target.value});
  handleloan_assessment_feesChange= (e) => this.setState({ loan_assessment_fees: e.target.value});
  handleloan_insurance_feeChange= (e) => this.setState({ loan_insurance_fee: e.target.value});
  handleloan_commitment_feeChange= (e) => this.setState({ loan_commitment_fee: e.target.value});
  handleloan_agreement_feesChange= (e) => this.setState({ loan_agreement_fees: e.target.value});
  handlereserve_feesChange= (e) => this.setState({ reserve_fees: e.target.value});
  handleinterest_rateChange= (e) => this.setState({ interest_rate: e.target.value});
  handlemaximum_loan_amountChange= (e) => this.setState({ maximum_loan_amount: e.target.value});
  handlemaximum_periodChange= (e) => this.setState({ maximum_period: e.target.value});


  render(){
    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{

      return (
        <div>
          <Form
            onFinish={(event) => this.handleFormSubmit(event)} 
          >
            <FormItem label="Loan Type Name"
              name="loan_type_name"
              rules={[
                {
                  required: true,
                  message: 'Please enter name',
                },
              ]}             
            >
              <Input name="loan_type_name"  placeholder="Put a name here." value={this.state.loan_type_name} onChange={this.handleloan_type_nameChange} />
            </FormItem>

            <FormItem label="Loan Form Fees"
              name="loan_form_fees"
              rules={[
                {
                  required: true,
                  message: 'Please enter values',
                },
              ]}           
            >
              <Input name="loan_form_fees"  placeholder="Block Figure eg 1000" value={this.state.loan_form_fees} onChange={this.handleloan_form_feesChange} />
            </FormItem>

  
            <FormItem label="Loan Processing Fees (Assessment)"
              name="loan_assessment_fees"
              rules={[
                {
                  required: true,
                  message: 'Please enter values',
                },
              ]}           
            >
              <Input name="loan_assessment_fees"  placeholder="Enter % value" value={this.state.loan_assessment_fees} onChange={this.handleloan_assessment_feesChange} />
            </FormItem>
  
            <FormItem label="Loan Protection Fees (Insurance)"
              name="loan_insurance_fee"
              rules={[
                {
                  required: true,
                  message: 'Please enter values',
                },
              ]}           
            >
              <Input name="loan_insurance_fee"  placeholder="Enter % value" value={this.state.loan_insurance_fee} onChange={this.handleloan_insurance_feeChange} />
            </FormItem>

            <FormItem label="Loan Commitment fees"
              name="loan_commitment_fee"
              rules={[
                {
                  required: true,
                  message: 'Please enter values',
                },
              ]}           
            >
              <Input name="loan_commitment_fee"  placeholder="Enter % value" value={this.state.loan_commitment_fee} onChange={(val)=>{this.setState({loan_commitment_fee:val.target.value})}} />
            </FormItem>

            <FormItem label="Loan Agreement fees"
              name="loan_agreement_fees"
              rules={[
                {
                  required: true,
                  message: 'Please enter values',
                },
              ]}           
            >
              <Input name="loan_agreement_fees"  placeholder="Enter % value" value={this.state.loan_agreement_fees} onChange={(val)=>{this.setState({loan_agreement_fees:val.target.value})}} />
            </FormItem>


            <FormItem label="Loan Reserve Fee (Savings loan security)"
              name="reserve_fees"
              rules={[
                {
                  required: true,
                  message: 'Please enter values',
                },
              ]}           
            >
              <Input name="reserve_fees"  placeholder="Enter % value" value={this.state.reserve_fees} onChange={this.handlereserve_feesChange} />
            </FormItem>

            <FormItem label="Photograph Fee (Optional)" >
              <Input name="photograph_fees"  placeholder="Enter % value" value={this.state.photograph_fees} onChange={(val)=>{this.setState({photograph_fees:val.target.value})}} />
            </FormItem>



            <FormItem label="Interest Rate (Annual)"
              name="interest_rate"
              rules={[
                {
                  required: true,
                  message: 'Please enter values',
                },
              ]}           
            >
              <Input name="interest_rate"  placeholder="Enter % value" value={this.state.interest_rate} onChange={this.handleinterest_rateChange} />
            </FormItem>

            <FormItem label="Maximum Loan Amount"
              name="maximum_loan_amount"
              rules={[
                {
                  required: true,
                  message: 'Please enter values',
                },
              ]}           
            >
              <Input name="maximum_loan_amount"  placeholder="0.00" value={this.state.maximum_loan_amount} onChange={this.handlemaximum_loan_amountChange} />
            </FormItem>

        


            <FormItem label="Maximum Loan Period"
              name="maximum_period"
              rules={[
                {
                  required: true,
                  message: 'Please enter values',
                },
              ]}           
            >
              <Input name="maximum_period"  placeholder="0" value={this.state.maximum_period} onChange={this.handlemaximum_periodChange} />
            </FormItem>

          

            {/* new formulas  */ }
            <FormItem 
                label="Interest rate Type"
                >
                    <Select 
                    value={this.state.interestrate_type} 
                    onChange={(val)=>{this.setState({interestrate_type:val})}}
                    placeholder="Interest rate Type" >
                      <Option value='flatinterest'>Flat Interest</Option>
                      <Option value='reducingBalanceInterest'>Reducing Balance</Option>
                    </Select>
            </FormItem>

            <FormItem 
                label="Loan Primary Schedule (Interest per day/weekly/monthly)"
                >
                    <Select 
                    value={this.state.loan_primary_schedule} 
                    onChange={(val)=>{this.setState({loan_primary_schedule:val})}}
                    placeholder="Loan Primary Schedule" >
                      <Option value='monthly'>Monthly</Option>
                      <Option value='weekly'>Weekly</Option>
                      <Option value='daily'>Daily</Option>
                    </Select>
            </FormItem>


            <FormItem label="Charges from">
                    <Select 
                    value={this.state.charges_from} 
                    onChange={(val)=>{this.setState({charges_from:val})}}
                    placeholder="Charges from" >
                      <Option value='loan'>Loan</Option>
                      <Option value='savings'>Savings</Option>
                    </Select>
            </FormItem>
 

            <FormItem label="loan limit" >
              <Input name="no_of_times_collateral_againstloanamount"  placeholder="x" value={this.state.no_of_times_collateral_againstloanamount} onChange={(val)=>{this.setState({no_of_times_collateral_againstloanamount:val.target.value})}} />
            </FormItem>

            <FormItem  label="Loan limit by">
                    <Select 
                    value={this.state.loan_limitby} 
                    onChange={(val)=>{this.setState({loan_limitby:val})}}
                    placeholder="Loan limit by" >
                      <Option value='collateral_value_division'>Loan limit by collateralvalue division </Option>
                      <Option value='collateral_value_multiplication'>Loan limit by collateralvalue multiplication</Option>
                    </Select>
            </FormItem>

            <FormItem label="Number of loan approvers"
              name="no_of_approvers"
              rules={[
                {
                  required: true,
                  message: 'Please enter values',
                },
              ]}           
            >
              <Input  placeholder="0" value={this.state.no_of_approvers} onChange={(val)=>{this.setState({no_of_approvers:val.target.value})}} />
            </FormItem>


          <FormItem label="PMT formula enabled on reducing balance?" >
            <Switch
                checked={this.state.pmt_formular_enabled_onreducingbalance}
                onChange={val=>{this.setState({pmt_formular_enabled_onreducingbalance:val})}}
                checkedChildren="True"
                unCheckedChildren="False"
                />
         </FormItem>


        <FormItem label="Transfer to savings onissuance?" >
            <Switch
                checked={this.state.transfer_tosavings_onissuance}
                onChange={val=>{this.setState({transfer_tosavings_onissuance:val})}}
                checkedChildren="True"
                unCheckedChildren="False"
                />
        </FormItem>


        <FormItem label="send sms on issuance?" >
            <Switch
                checked={this.state.send_sms_onissuance}
                onChange={val=>{this.setState({send_sms_onissuance:val})}}
                checkedChildren="True"
                unCheckedChildren="False"
                />
        </FormItem>

        <FormItem label="send sms on repayment?" >
            <Switch
                checked={this.state.send_sms_on_repayment}
                onChange={val=>{this.setState({send_sms_on_repayment:val})}}
                checkedChildren="True"
                unCheckedChildren="False"
                />
        </FormItem>

          <h3>Ledger account settings</h3>


<FormItem label={"Account_tocreditloanprinciple_ondeposit"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocreditloanprinciple_ondeposit}
      onChange={(val)=>{this.setState({account_tocreditloanprinciple_ondeposit:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>


  <FormItem label={"Account_tocreditloaninterestpaid_ondeposit"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocreditloaninterest_ondeposit}
      onChange={(val)=>{this.setState({account_tocreditloaninterest_ondeposit:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>



  <FormItem label={"Account_todebitloaninterestreceivable_ondeposit"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_todebitloaninterest_ondeposit}
      onChange={(val)=>{this.setState({account_todebitloaninterest_ondeposit:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>

<FormItem label={"Account_todebit_onloan_onloanissuance"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_todebit_onloan_onloanissuance}
      onChange={(val)=>{this.setState({account_todebit_onloan_onloanissuance:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>


  <h3>Loan fines credit accounts</h3>


  <FormItem label={"Account_todebit_on_acculatedloanfines"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_todebit_on_acculatedloanfines}
      onChange={(val)=>{this.setState({account_todebit_on_acculatedloanfines:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>


  <FormItem label={"Account_tocredit_on_paidloanfines"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocredit_on_paidloanfines}
      onChange={(val)=>{this.setState({account_tocredit_on_paidloanfines:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>

  <h3>Issuance Charges credit accounts</h3>

  <FormItem label={"Account_tocredit_onbankcharge_onloanissuance"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocredit_onbankcharge_onloanissuance}
      onChange={(val)=>{this.setState({account_tocredit_onbankcharge_onloanissuance:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>


  <FormItem label={"Account_tocredit_onloanfees_onloanissuance"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocredit_onloanfees_onloanissuance}
      onChange={(val)=>{this.setState({account_tocredit_onloanfees_onloanissuance:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>


    <FormItem label={"Account_tocredit_onreservefee"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocredit_onreservefee}
      onChange={(val)=>{this.setState({account_tocredit_onreservefee:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>


  <FormItem label={"Account_tocredit_onassessment_fees"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocredit_onassessment_fees}
      onChange={(val)=>{this.setState({account_tocredit_onassessment_fees:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>


  <FormItem label={"Account_tocredit_oninsurance_fee"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocredit_oninsurance_fee}
      onChange={(val)=>{this.setState({account_tocredit_oninsurance_fee:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>


  <FormItem label={"Account_tocredit_oncommitment_fee"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocredit_oncommitment_fee}
      onChange={(val)=>{this.setState({account_tocredit_oncommitment_fee:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>

  <FormItem label={"Account_tocredit_onagreement_fees"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocredit_onagreement_fees}
      onChange={(val)=>{this.setState({account_tocredit_onagreement_fees:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>


  <FormItem label={"Account_tocredit_onphotograph_fees"}>
      <Select 
      placeholder="Account" 
      style={{  }} 
      value={this.state.account_tocredit_onphotograph_fees}
      onChange={(val)=>{this.setState({account_tocredit_onphotograph_fees:val})}} 
      showSearch
      optionFilterProp="children"
      onFocus={this.onFocus}
      onBlur={this.onBlur}
      onSearch={this.onSearch}                    
      >
        {this.state.companyaccounts.map(
          (accnt)=>(
            <Option value={accnt.id}>{accnt.account_name} | {accnt.account_code}</Option>
          ))}
      </Select>
  </FormItem>

      <h3>Auto payment settings</h3>
      <FormItem label="Auto repayment after full cycle?" >
            <Switch
                checked={this.state.autoPayments_afterfullcycle}
                onChange={val=>{this.setState({autoPayments_afterfullcycle:val})}}
                checkedChildren="True"
                unCheckedChildren="False"
                />
        </FormItem>



    <FormItem>
      <Button  type="primary" htmlType="submit">Create</Button>
    </FormItem>
    </Form>
        </div>
      );


    }

  }

}


export default LoanTypeForm;



